<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<vs-table :sst="true" class="shadow-none border-none table-auto" stripe :data="$store.state.moduleProduct && $store.state.moduleProduct.myOrders" @sort="handleSort">
			<div slot="header" class="mb-12 w-full" style="align-items: center; align-items: center;display: flex;flex-direction: row;width: 100%;overflow-x: scroll;">
				<h4 class="font-bold">Sổ lệnh</h4>
				<div class="" :key="`${upStatus}--1`" style="min-width: 100px; margin-left: 15px;">
					<vs-button title="Tìm theo khớp giá" class="font-bold ml-3 w-full" :color="'#626262'" :type="isAll ? 'filled' : 'border'" @click="filterByStatus(-1)">Tất cả</vs-button>
				</div>
				<div class="" :key="`${upStatus}-${idxStatus}`" v-for="(statusLabel, idxStatus) in statusList" style="min-width: 150px; margin-left: 15px;">
					<vs-button title="Tìm theo khớp giá" class="font-bold ml-3 w-full" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
				</div>
			</div>
			<template slot="thead">
				<vs-th sort-key="id" style="min-width:80px;"><h6 class="uppercase font-bold">Mã</h6></vs-th>
				<vs-th v-if="canSelectSupplier" sort-key="product_id" style="min-width:120px;"><h6 class="uppercase font-bold">NCC</h6></vs-th>
				<vs-th sort-key="product_id" style="min-width:120px;"><h6 class="uppercase font-bold">Loại PP</h6></vs-th>
				<vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Đơn giá</h6></vs-th>
				<vs-th sort-key="quantity" style="min-width:100px;"><h6 class="uppercase font-bold">KL</h6></vs-th>
				<vs-th sort-key="created_at" style="min-width:100px;" v-if="canSell"><h6 class="uppercase font-bold">Ngày tạo</h6></vs-th>
				<vs-th sort-key="created_at" style="min-width:100px;" v-if="canSell"><h6 class="uppercase font-bold">Nơi giao</h6></vs-th>
				<vs-th sort-key="updated_at" style="min-width:100px;" v-if="canBuy"><h6 class="uppercase font-bold">Ngày khớp</h6></vs-th>
				<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">Trạng thái</h6></vs-th>
				<vs-th sort-key="" style="min-width:100px;"><h6 class="uppercase font-bold"></h6></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)">
					<vs-td>
						<p class="word-break uppercase">
							#{{ tr.id }}
						</p>
					</vs-td>
					<vs-td v-if="canSelectSupplier">
						<p class="word-break">
							{{ tr.supplier_name }}
						</p>
					</vs-td>
					<vs-td>
						<p class="word-break">
							{{ tr.product ? tr.product.name : '-' }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{ 'word-break': 1 }">
							{{ $helper.numFormat(tr.price) }}
						</p>
					</vs-td>
					<vs-td>
						<p :class="{ 'word-break': 1 }">
							{{ $helper.numFormat(tr.quantity) }} <sup v-if="tr.quantity_extra" style="color: rgb(210, 172, 36)">{{(tr.quantity_extra > 0 ? '+' :'') + $helper.numFormat(tr.quantity_extra)}}</sup>
						</p>
					</vs-td>
					<vs-td v-if="canSell">
						<p class="word-break uppercase">
							{{ $helper.momentFormatLocale(tr.created_at) }}
						</p>
					</vs-td>
					<vs-td v-if="canSell">
						<p class="word-break uppercase">
							{{ tr.matching ? tr.matching.cus_address : '' }}
						</p>
					</vs-td>
					<vs-td v-if="canBuy">
						<p class="word-break uppercase">
							{{ tr.status >= 2 && tr.status != 16 ? $helper.momentFormatLocale(tr.matching_buy ? tr.matching_buy.created_at : (tr.matching ? tr.matching.created_at : tr.updated_at) ) : '-' }}
						</p>
					</vs-td>
					<vs-td :set="statusDirective = $helper.getStatusAndDirective(tr.status)">
						<p :class="{ 'word-break': 1 }">
							<label :class="statusDirective.directive">
								{{ statusDirective.name}}
							</label>
						</p>
					</vs-td>
					<vs-td >
						<div class="flex items-center justify-start">
							<div style="cursor: pointer; padding-left: 6px;" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status < 2" @click.stop="onClickCancelOrder(tr.id, $event)">
								<i class="nucleo mr-1 text-danger nucleo-trash-can" />
								<span class="label text-danger">Hủy lệnh</span>
							</div>
							<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status < 2" @click.stop="onClickEditOrder(tr, $event)">
								<i class="nucleo mr-1 text-primary nucleo-edit" />
								<span class="label text-primary">Sửa lệnh</span>
							</div>
							<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>2 && tr.status != 8 && tr.status != 16 && tr.type == 2" @click.stop="onClickShippingOrder(tr, $event)">
								<i class="nucleo mr-1 text-primary nucleo-file-text" />
								<span class="label text-primary">Vận đơn</span>
							</div>
							<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>=2 && tr.status != 8 && tr.status != 16" @click.stop="onClickSellerRating(tr, $event)">
								
								<span class="label text-warning flex" style="align-items: center;"><i class="material-icons" style="width: 22px; margin-right: 5px; font-size: 22px;">star_rate</i>Đánh giá</span>
							</div>
							<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>=1 && tr.status != 8 && tr.status != 16 && tr.type == 1" @click.stop="onClickChooseSells(tr, $event)">
								<i class="nucleo mr-1 text-primary nucleo-file-text" />
								<span class="label text-primary">Lệnh bán</span>
							</div>
							<!--<div id="test" style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status>=2 && tr.type==2" @click.stop="printOrder(tr, $event)">
								<i class="nucleo mr-1 text-primary nucleo-file-text" />
								<span class="label text-primary">In phiếu</span>
							</div>-->
						</div>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
		<div class="w-full center mt-4">
			<CbsPagination :total="total" v-model="page"></CbsPagination>
		</div>
		<OrderForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
		<OrderDetail :isPopupActive="isDetailUserDialogActive" @closePopup="toggleDetailSidebar" :data="detailUserDialogData" />
		<KcsForm :isPopupActive="shippingDialog" @closePopup="toggleShippingDialog" :data="shippingData" />
		<ChooseSells :isPopupActive="sellsDialog" @closePopup="toggleSellsDialog" :data="sellsData" />
		<SellerRatingForm :isPopupActive="sellerRatingDialog" @closePopup="toggleSellerRatingDialog" :data="sellerRatingData" />

		<div class="btn-order-action">
			<button class="vs-component vs-button w-48 font-bold vs-button-primary vs-button-filled ml-4 mr-4" v-if="canBuy && !customerDialog" @click="handleOrderAction(1)">Mua</button>
			<button class="vs-component vs-button w-48 font-bold vs-button-primary vs-button-filled ml-4 mr-4" v-if="canSell && !customerDialog && !shippingDialog" @click="handleOrderAction(2)">Bán</button>
		</div>
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import OrderDetail from "./OrderDetail.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		OrderDetail,
		KcsForm,
		ChooseSells,
		SellerRatingForm
	},
	data() {
		return {
			isAll: false,
			statusList: [
				// {
				// 	id: -1,
				// 	name: window.innerWidth > 600 ? 'Tất cả' : 'Tất cả',
				// 	active: 0,
				// 	color: '#626262',
				// },
				{
					id: 0,
					name: window.innerWidth > 600 ? 'Đang chờ' : 'Đang chờ',
					active: 0,
					color: 'primary',
				},
				{
					id: 1,
					name: window.innerWidth > 600 ? 'Khớp giá' : 'Khớp giá',
					active: 0,
					color: 'warning',
				},
				{
					id: 2,
					name: window.innerWidth > 600 ? 'Khớp lệnh' : 'Khớp lệnh',
					active: 0,
					color: 'success',
				},
				{
					id: 4,
					name: window.innerWidth > 600 ? 'Đã duyệt' : 'Đã duyệt',
					active: 0,
					color: '#030960',
				},
				{
					id: 2056,
					name: window.innerWidth > 600 ? 'Đang VC' : 'Đang VC',
					active: 0,
					color: '#D2AC24',
				},
				{
					id: 64,
					name: window.innerWidth > 600 ? 'Hoàn thành VĐ' : 'HT VĐ',
					active: 0,
					color: '#030960',
				},
				{
					id: 128,
					name: window.innerWidth > 600 ? 'Đã thanh toán' : 'Đã TT',
					active: 0,
					color: '#057FBB',
				},
			],
			sellerRatingDialog: false,
			sellerRatingData: {},
			shippingDialog: false,
			shippingData: {},
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,
			customerData: {},
			userToken: '',
			sellsDialog: false,
			sellsData: {},
			upStatus: Date.now()
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.myOrdersTotal / this.$store.state.moduleProduct.limit);
		},
	},
	methods: {
		filterByStatus(idxStatus) {
			if (idxStatus == -1) {
				this.isAll = !this.isAll;
			} else {
				this.isAll = false;
			}
			this.statusList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (this.isAll) {
					status.active = 0;
				}
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getGetUsers();
		},
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/shipping-print/'+item.id+'?token='+this.userToken, '', 'height=800, width=800');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		onClickCancelOrder(id, event) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: 'Thực hiện hủy lệnh số #'+id,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.cancelOrder(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
			if (event) {
				event.preventDefault()
			}
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickSellerRating(data, event) {
			let matchingId = 0;
			let cusName = '';
			if (data.type == 2) {
				matchingId = data.matching.id || '';
				cusName = data.matching.cus_name || '';
			} else {
				matchingId = data.matching_buy.id || '';
				cusName = data.matching_buy.supplier_name || '';
			}
			this.sellerRatingData = {
				type: data.type,
				id: data.id,
				matchId: matchingId,
				buyer_name: cusName,
				rating: data.rating,
				rating_note: data.rating_note
			};
			this.sellerRatingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickShippingOrder(data, event) {
			this.shippingData = {
				id: data.matching.id
			};
			this.shippingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickChooseSells(data, event) {
			this.sellsData = {
				id: data.id,
				status: data.status,
			};
			this.sellsDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload);
			} catch (error) {
				console.log(error.message);
			}
		},
		async getGetUsers() {
			this.$vs.loading();
			let statuses = [];
			let isAll = false;
			this.statusList.map(status => {
				if (status.active) {
					if (status.id == -1) {
						isAll = true;
					}
					statuses.push(status.id);
				}
			});
			// console.log(this.statusList);
			this.filters.statuses = !isAll ? statuses : [];
			const payload = {
				filters: this.filters,
				id: 0,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				sort: this.sort
			};
			try {
				await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},
	
		toggleShippingDialog(val = false) {
			this.shippingDialog = val;
		},
		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		toggleSellerRatingDialog(val = false) {
			this.sellerRatingDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleSellsDialog(val = false) {
			this.sellsDialog = val;
			if (!val) {
				this.sellsData = {};
				this.getGetUsers();
			}
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
	},
	created() {
		// Register Module UserManagement Module
		this.getGetUsers();
		this.getProducts();

		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { supplier_can_select = false, user_can_buy = false, user_can_sell = false } = permissions;
			if (user_can_buy) {
				this.canBuy = true;
			}
			if (user_can_sell) {
				this.canSell = true;
			}
			if (supplier_can_select) {
				this.canSelectSupplier = true;
			}
			this.userToken = token;

			if (user_can_buy && !user_can_sell) {
				this.statusList = [
					{
						id: 0,
						name: window.innerWidth > 600 ? 'Đang chờ' : 'Chờ',
						active: 0,
						color: 'primary',
					},
					{
						id: 1,
						name: window.innerWidth > 600 ? 'Khớp giá' : 'Khớp giá',
						active: 0,
						color: 'warning',
					},
					{
						id: 2,
						name: window.innerWidth > 600 ? 'Khớp lệnh' : 'Khớp lệnh',
						active: 0,
						color: 'success',
					},
					{
						id: 4,
						name: window.innerWidth > 600 ? 'Đã duyệt' : 'Đã duyệt',
						active: 0,
						color: '#030960',
					},
					{
						id: 2056,
						name: window.innerWidth > 600 ? 'Đang VC' : 'Đang VC',
						active: 0,
						color: '#D2AC24',
					},
					{
						id: 64,
						name: window.innerWidth > 600 ? 'Hoàn thành VĐ' : 'HT VĐ',
						active: 0,
						color: '#030960',
					},
					{
						id: 128,
						name: window.innerWidth > 600 ? 'Đã thanh toán' : 'Đã TT',
						active: 0,
						color: '#057FBB',
					},
				];
			} else if (!user_can_buy && user_can_sell) {
				this.statusList = [
					{
						id: 0,
						name: window.innerWidth > 600 ? 'Đang chờ' : 'Chờ',
						active: 0,
						color: 'primary',
					},
					{
						id: 2,
						name: window.innerWidth > 600 ? 'Khớp lệnh' : 'KL',
						active: 0,
						color: 'success',
					},
					{
						id: 128,
						name: window.innerWidth > 600 ? 'Đã thanh toán' : 'TT',
						active: 0,
						color: 'dark',
					},
				];
			}
		}
		if (typeof localStorage === 'object' && localStorage) {
			let forceRelogin = localStorage.getItem('relogin');
			if (!forceRelogin) {
				localStorage.removeItem("accessToken");
				this.$acl.change("guest");
				localStorage.removeItem("userInfo");
				this.$router.push("/pages/login").catch(() => {});
				window.location = '/';
			}
		}
	},
};
</script>

<style lang="scss">
.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
